export default "__VITE_ASSET__B_NaW4ZN__"